<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/member' }">结算管理</el-breadcrumb-item>
            <el-breadcrumb-item>待支付项目</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form inline label-position="right" :model="formFilter" label-width="80px">
                <el-form-item label="项目名称">
                    <el-input v-model="formFilter.project_name" placeholder="请输入项目名称"></el-input>
                </el-form-item>
                <el-form-item label="服务人员">
                    <el-input v-model="formFilter.name" placeholder="请输入服务人员"></el-input>
                </el-form-item>
                <el-form-item label="服务编号">
                    <el-input v-model="formFilter.sub_no" placeholder="请输入服务编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onFilter" type="primary">查询</el-button>
                    <el-button v-if="list.length > 0" @click="onExport" type="default">导出</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <div class="table" style="padding-top: 15px;">
                <el-table
                    :data="list"
                    border
                    stripe
                    @selection-change="selectionChange"
                    ref="prePaidTable"
                >
                    <el-table-column
                        align="center"
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        prop="create_time"
                        align="center"
                        show-overflow-tooltip
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        prop="project_name"
                        align="center"
                        show-overflow-tooltip
                        label="项目名称">
                    </el-table-column>
                    <el-table-column
                        prop="sub_no"
                        show-overflow-tooltip
                        align="center"
                        label="服务编号">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        show-overflow-tooltip
                        align="center"
                        label="服务人员">
                    </el-table-column>
                    <el-table-column
                        prop="money"
                        show-overflow-tooltip
                        align="center"
                        label="服务金额">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        show-overflow-tooltip
                        label="服务状态">
                        <template slot-scope="scope">
                            {{statusList[scope.row.status]}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作">
                        <template slot-scope="scope">
                            <el-button type="text"
                                       @click="goPage(`/index/project/servicepayinfo?id=${scope.row.id}&sub_id=${scope.row.sub_id}&pre_id=${scope.row.pre_id}`)">
                                支付
                            </el-button>
                            <el-button type="text" @click="closePayment(scope.row.id, scope.row.sub_id)">取消</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="table-extra">
                    <div class="operation">
                        <el-checkbox @change="serviceTableSelectChange" v-model="isCheckAll"
                                     :indeterminate="isIndeterminate"></el-checkbox>
                        <el-button type="default" :disabled="packStatus" @click="packPay" size="medium"
                                   style="margin-right: 10px;">
                            合并付款
                        </el-button>
                        <el-button type="default" :disabled="packStatus" @click="packClosePay" size="medium"
                                   style="margin-right: 10px;">
                            取消付款
                        </el-button>
                    </div>
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="prev, pager, next, sizes"
                            :page-size="pageSize"
                            :page-sizes="[20, 50, 100]"
                            :current-page="currentPage"
                            @current-change="onPageChange"
                            @size-change="pageSizeChange"
                            :page-count="total_page">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'
import { mapState } from 'vuex'

export default {
    name: 'PrePaid',
    inject: ['goPage'],
    data () {
        const statusList = ['待企业确认用户服务', '待用户确认服务', '服务进行中', '待支付服务成果', '待平台审核服务成果', '审核失败，待重新确认', '服务成果待用户确认', '用户异议，待重新确认', '待用户申请结算', '待确认服务结算', '打款中', '打款失败，请联系客服', '重新发起打款', '已完成', '已关闭', '用户拒绝,已关闭']
        return {
            statusList,
            formFilter: {
                project_name: '',
                name: '',
                sub_no: ''
            },
            form: {
                project_name: '',
                name: '',
                sub_no: ''
            },
            isCheckAll: false,
            isIndeterminate: false,
            packStatus: true,
            list: [],
            total_page: 1,
            pageSize: 20
        }
    },
    computed: {
        ...mapState({
            currentPage: 'curPage',
            condition: 'formFilter'
        })
    },
    mounted () {
        if (this.condition) {
            this.formFilter = this.condition
        }
        this.getList()
    },
    methods: {
        onFilter () {
            this.$store.commit('changeCondition', this.formFilter)
            this.getList(1)
            this.form = this.formFilter
        },
        onPageChange (e) {
            this.$store.commit('changePage', e)
            this.getList(e)
        },
        pageSizeChange (e) {
            this.pageSize = e
            this.getList(1)
        },
        selectionChange (selection) {
            this.isIndeterminate = selection.length > 0 && selection.length < this.list.length
            this.isCheckAll = !(selection.length === 0)
            this.packStatus = !(this.$refs.prePaidTable.selection.length > 1)
        },
        serviceTableSelectChange (e) {
            this.$refs.prePaidTable.toggleAllSelection(e)
        },
        onExport () {
            this.download(`${process.env.VUE_APP_BASE}/api/user/downsubtopay?project_name=${this.form.project_name}&sub_no=${this.form.sub_no}&name=${this.form.name}`, '待支付项目列表.xls')
        },
        download (url, fileName = '') {
            let eleLink = document.createElement('a')
            let authorization = localStorage.getItem('token')
            eleLink.download = fileName
            eleLink.style.display = 'none'
            eleLink.href = url + '&authorization=' + authorization
            document.body.appendChild(eleLink)
            eleLink.click()
            document.body.removeChild(eleLink)
        },
        getList (page = this.currentPage) {
            this.$http.get('/api/user/project/subtopay', {
                params: {
                    ...this.formFilter,
                    page,
                    size: this.pageSize,
                    project_name: this.formFilter.project_name,
                    sub_no: this.formFilter.sub_no,
                    name: this.formFilter.name
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.list = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        closePayment (id, sub_id) {
            this.$confirm('确认取消该服务成果？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.queryClosePayment(id, sub_id)
                })
        },
        queryClosePayment (id, sub_id) {
            this.$http.get('/api/user/project/subtopayclose', {
                params: {
                    id,
                    sub_id
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.$notify.success({
                            title: '通知',
                            message: '服务成果取消成功。'
                        })
                        this.getList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        packClosePay () {
            let lists = this.$refs.prePaidTable.selection.map(item => item.sub_id)
            this.$confirm('确认批量取消服务成果？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.queryPackClosePay(lists)
                })
        },
        queryPackClosePay (lists) {
            this.$http.post('/api/user/project/batchsubtopayclose', qs.stringify({
                sub_ids: JSON.stringify(lists)
            }))
                .then(res => {
                    if (res.code === 0) {
                        this.$notify.success({
                            title: '通知消息',
                            message: '批量取消待付款服务成果成功'
                        })
                        this.getList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        packPay () {
            let lists = this.$refs.prePaidTable.selection.map(item => {
                return {
                    pre_id: item.pre_id,
                    sub_id: item.sub_id
                }
            })
            this.queryPackPay(lists)
        },
        queryPackPay (lists) {
            this.$http.post('/api/user/project/newbatchpayinfo', qs.stringify({
                lists: JSON.stringify(lists)
            }))
                .then(res => {
                    if (res.code === 0) {
                        localStorage.removeItem('PACKPAY')
                        localStorage.setItem('PACKPAY', JSON.stringify(res.data))
                        router.push('/index/pay/packpay')
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../../assets/style/sub.scss";
</style>
